/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ComponentRef, Injectable, Renderer2 } from '@angular/core';
import type { ProcessRowParams } from 'ag-grid-community';

import { assign } from 'lodash';

import { GRID_EVENT } from '../../grid-public-events';
import { AbstractGridOptionBarFeature } from './abstract-grid-option-bar-feature';

import { GridRowInitParams, GridRowOptionsComponent } from './grid-row-options-component';

@Injectable()
export class GridHoverOptionBarFeature extends AbstractGridOptionBarFeature {
  private componentRef: Maybe<ComponentRef<GridRowOptionsComponent>>;
  private currentRow: Maybe<GridRowInitParams>;

  constructor(protected renderer: Renderer2) {
    super();
  }

  process(params: ProcessRowParams): void {
    const mouseEnter = (): void => {
      this.createAndAttachComponent(params);
    };
    const mouseLeave = (): void => {
      this.detachAndDestroyComponent(params);
    };

    params.eRow.addEventListener('mouseenter', mouseEnter);
    params.eRow.addEventListener('mouseleave', mouseLeave);

    params.addRenderedRowListener(GRID_EVENT.virtualRowRemoved, () => {
      params.eRow.removeEventListener('mouseenter', mouseEnter);
      params.eRow.removeEventListener('mouseleave', mouseLeave);
    });
  }

  private createAndAttachComponent(row: GridRowInitParams): void {
    const { currentRow } = this;
    const currentNode = currentRow && currentRow.node.id === row.node.id;
    if (currentNode) {
      return;
    } else {
      this.detachAndDestroyComponent(row);
    }
    const componentRef = this.createComponent();
    this.attachComponent(row, componentRef);

    assign(this, { componentRef, currentRow: row });
  }

  private detachAndDestroyComponent(row: GridRowInitParams): void {
    this.detachComponent(row);
    if (this.currentRow && this.componentRef) {
      this.componentRef.destroy();
      this.componentRef = undefined;
      this.currentRow = undefined;
    }
  }

}
